import { PaginatedChristmasBonusQueryVariables } from "@/graphql/__generated__/graphql";
import ValueRangeFilter from "../../Shared/ValueRangeFilter";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedChristmasBonusQueryVariables) => void;
}

/**
 * ChristmasBonusValueRange component for filtering christmas bonus by value ranges
 * Handles both bonusRelative and bonusAbsolute value range filters
 * @param props Component properties
 * @returns JSX element
 */
function ChristmasBonusValueRange({ displayAmount, handleSubmitClick }: Props) {
  const christmasBonusValueConfig = {
    paginationStateKey: "paginatedChristmasBonus" as keyof PaginationState,
    fields: [
      {
        fieldName: "bonusRelative",
        labelKey: "components:filters.christmasbonus.sortfields.bonusrelative",
        inputStyle: "decimal" as const,
        useBasisPoints: true,
        suffix: "%",
        decimalScale: 2,
        placeholder: "0.00"
      },
      {
        fieldName: "bonusAbsolute",
        labelKey: "components:filters.christmasbonus.sortfields.bonusabsolute",
        inputStyle: "currency" as const,
        useBasisPoints: false,
        decimalScale: 2,
        placeholder: "0.00"
      }
    ],
    defaultButtonTextKey: "components:filters.christmasbonus.value",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      valueRanges: Record<string, { gte: number | null; lte: number | null }>,
      sort?: any
    ): PaginatedChristmasBonusQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: filters.activeFrom || null,
        bonusRelative: valueRanges.bonusRelative,
        bonusAbsolute: valueRanges.bonusAbsolute,
        provinces: filters.provinces || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      bonusRelative: paginationState.filters?.bonusRelative,
      bonusAbsolute: paginationState.filters?.bonusAbsolute,
      provinces: paginationState.filters?.provinces
    })
  };

  return (
    <ValueRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={christmasBonusValueConfig}
    />
  );
}

export default ChristmasBonusValueRange;
